import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { GetMyDueItemsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import dayjs from 'dayjs';

import type { MyOverdueItemFields } from '../../my-items/config';
import { useGetMyOverdueItemsSmartWidgetTableProps } from '../../my-items/config';
import { getQueryVariables } from '../../my-items/hooks/useGetQueryVariables';
import { createDataSource } from '../createDataSource';

const createMyItemsDataSource = (dueDateLength: number) =>
  createDataSource<
    MyOverdueItemFields,
    VariablesOf<typeof GetMyDueItemsDocument>,
    ResultOf<typeof GetMyDueItemsDocument>
  >({
    parentTypes: [],
    hasAccess: () => true,
    documentNode: GetMyDueItemsDocument,
    trpcQuery: () => {
      // TODO: Implement tRPC query for my overdue items when trpc request has been implemented
      return {
        enabled: false,
        queryKey: ['myOverdueItems', 'disabled'],
        queryFn: () => Promise.resolve(null),
      };
    },
    useDefaultVariables: (userId) => {
      const date = dayjs().add(dueDateLength, 'day').endOf('day').toISOString();

      return {
        userId: userId ?? '',
        date,
        riskFilterConditions: {},
        actionFilterConditions: {},
        assessmentFilterConditions: {},
        controlFilterConditions: {},
        issueFilterConditions: {},
        assessmentActivityFilterConditions: {},
        documentFilterConditions: {},
        obligationFilterConditions: {},
      };
    },
    useTablePropsHook: (data, options) =>
      useGetMyOverdueItemsSmartWidgetTableProps(data, options),
    fields: 'dashboard.myItemsDashboard.fields',
    entityNamePlural: 'my_item_other',
    entityNameSingular: 'my_item_one',
    dashboardFilterConfig: {
      ownershipFilter: getQueryVariables,
    },
    categoryGetters: [],
  });

export const myOverdueItems7Days = createMyItemsDataSource(7);
export const myOverdueItems30Days = createMyItemsDataSource(30);
